import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useSearchParams } from "react-router-dom";
import { useTahun } from "@/hooks/useTahun";

const getListDataLoa = async (
  limit?: string,
  page?: string,
  search?: string,
  status?: string,
  tahun?: string,
) => {
  const params = new URLSearchParams(location.search);
  if (limit) params.set("limit", limit);
  if (page) params.set("page", page);
  if (search) params.set("search", search);
  if (status) params.set("status", status);
  if (tahun) params.set("tahun", tahun);

  const response = await api.get(
    `/operator-pasca/data-loa/index?${params.toString()}`,
  );
  return response.data?.data;
};

export default function DataLoaPage() {
  const [searchParams] = useSearchParams();
  const limitParams = searchParams.get("rowsPerPage") || "";
  const pageParams = searchParams.get("page") || "";
  const searchQueryParams = searchParams.get("search") || "";
  const statusParams = searchParams.get("status") || "";

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataLoa",
      limitParams,
      pageParams,
      searchQueryParams,
      statusParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListDataLoa(
        limitParams,
        pageParams,
        searchQueryParams,
        statusParams,
        selectedTahun?.label,
      ),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
      />
    </div>
  );
}
